import { render, staticRenderFns } from "./PaginaAdminRegiones.vue?vue&type=template&id=3c6ccded"
import script from "./PaginaAdminRegiones.vue?vue&type=script&lang=js"
export * from "./PaginaAdminRegiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports